<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_The_name') + '*'"
                             :readonly="disabled"
                             :isNational="judegNational('given_name')"
                             :error-messages="$errors('stafflist', 'given_name', requiredRule)"
                             v-model="stafflist.given_name">
          </mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_Surname') + '*'"
                             :readonly="disabled"
                             :isNational="judegNational('family_name')"
                             :error-messages="$errors('stafflist', 'family_name', requiredRule)"
                             v-model="stafflist.family_name">
          </mrc_ess_multiText>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_Show_the_name') + '*'"
                             :isNational="judegNational('show_name')"
                             :error-messages="$errors('stafflist', 'show_name', requiredRule)"
                             :readonly="disabled"
                             v-model="stafflist.show_name">
          </mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_dictName v-model="stafflist.gender"
                            :disabled="disabled"
                            :chips="false"
                            :errMsg="$errors('stafflist', 'gender', requiredRule)"
                            :label="$t('label_Gender') + '*'"
                            :rules="false"
                            :isNational="judegNational('gender')"
                            dict_name="gender">
          </mrc_ess_dictName>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <mrc_ess_brandupload v-model="stafflist.staff_image"
                               v-if="branduploadstatus"
                               :label="$t('label_Photo')"
                               :disabled="disabled"
                               @changeimgSrc="changeimgSrc"></mrc_ess_brandupload>
          <!-- 上传 -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <!-- 2025-04-27 BJ 邮箱非必填-->
          <!-- :label="$t('label_Mailbox') + '*'" -->
          <mrc_ess_multiText :label="$t('label_Mailbox')"
                             :isNational="judegNational('staff_email')"
                             :error-messages="$errors('stafflist', 'staff_email',emailRule)"
                             :readonly="disabled"
                             v-model="stafflist.staff_email">
          </mrc_ess_multiText>
          <!-- $errors('stafflist', 'staff_email', [...requiredRule, ...emailRule]) -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <mrc_ess_multiText :label="$t('label_Employee_ID') + '*'"
                             :isNational="judegNational('staff_code')"
                             :error-messages="$errors('stafflist', 'staff_code', requiredRule.concat(nocharacter))"
                             :readonly="disabled"
                             @blur="blur"
                             v-model="stafflist.staff_code">
          </mrc_ess_multiText>
        </v-col>
        <v-col cols="6">
          <mrc_ess_autoComplete :label="$t('label_addStaff_m_staffType') + '*'"
                                :readonly="disabled"
                                :error-messages="$errors('stafflist', 'staff_type', requiredRule)"
                                v-model="stafflist.staff_type"
                                :prompt_name="staffTypePro">
          </mrc_ess_autoComplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <!-- <mrc_ess_prompt :label="$t('label_department')+'*'"
                          :errMsg="$errors('stafflist','dept_uuid',requiredRule)"
                          :rules='false'
                          :disabled='disabled'
                          v-model="stafflist.dept_uuid"
                          :obj="companyName">
          </mrc_ess_prompt> -->
          <mrc_ess_autoComplete :label="$t('label_department') + '*'"
                                :readonly="disabled"
                                :error-messages="$errors('stafflist', 'dept_uuid', requiredRule)"
                                deptView
                                v-model="stafflist.dept_uuid"
                                :prompt_name="companyName">
          </mrc_ess_autoComplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12"
               sm="6">
          <!-- <mrc_ess_prompt :label="$t('label_Position_Title')+'*'"
                          :rules='false'
                          :disabled='disabled'
                          v-model="stafflist.job_post_uuid"
                          :obj="job_post_uuid">
          </mrc_ess_prompt> -->
          <mrc_ess_autoComplete :label="$t('label_Position_Title') + '*'"
                                :readonly="disabled"
                                positionView
                                :error-messages="$errors('stafflist', 'job_post_uuid', requiredRule)"
                                v-model="stafflist.job_post_uuid"
                                :prompt_name="job_post_uuid">
          </mrc_ess_autoComplete>
        </v-col>
        <v-col cols="12"
               sm="6">
          <!-- <mrc_ess_prompt :label="$t('label_Post_grades') + '*'"
                          :errMsg="$errors('stafflist', 'job_post_grade_uuid', requiredRule)"
                          :rules="false"
                         :disabled="disabled"
                          v-model="stafflist.job_post_grade_uuid"
                          :obj="mrbase_sys_job_post_grades">
          </mrc_ess_prompt> -->
          <!-- <mrc_ess_autoComplete :label="$t('label_Post_grades') + '*'"
                                :readonly="disabled"
                                postGradesView
                                :error-messages="$errors('stafflist', 'job_post_grade_uuid', requiredRule)"
                                v-model="stafflist.job_post_grade_uuid"
                                :prompt_name="mrbase_sys_job_post_grades">
          </mrc_ess_autoComplete> -->
          <!-- 员工等级 -->
          <mrc_ess_autoComplete :label="$t('label_addStaff_m_staffGrade') + '*'"
                                :readonly="disabled"
                                :error-messages="$errors('stafflist', 'staff_grade', requiredRule)"
                                v-model="stafflist.staff_grade"
                                :prompt_name="staffGrade">
          </mrc_ess_autoComplete>

        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col cols="12"
               sm="3">
          <v-checkbox class="mx-2"
                      :true-value="1"
                      :false-value="0"
                      v-model="stafflist.is_org_manager"
                      :label="$t('label_The_person_in_charge_of_the_unit')"></v-checkbox>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-checkbox class="mx-2"
                      :true-value="1"
                      :false-value="0"
                      v-model="stafflist.is_dept_manage"
                      :label="$t('label_Department_head')"></v-checkbox>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="12">
          <mrc_ess_prompt :label="$t('label_Boss')"
                          :rules="false"
                          :disabled="disabled"
                          v-model="stafflist.direct_leader_code"
                          :obj="superior">
          </mrc_ess_prompt>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <mrc_ess_prompt :label="$t('label_role') + '*'"
                          :rules="false"
                          :errMsg="$errors('stafflist', 'role_uuids', requiredRule)"
                          multiple
                          :disabled="disabled"
                          v-model="stafflist.role_uuids"
                          :obj="spica">
          </mrc_ess_prompt>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
               sm="6">
          <mrc_ess_datePicker :disabled="false"
                              :errMsg="
              $errors(
                'stafflist',
                'entry_datetime',
                requiredRule.concat([
                  {
                    rule: 'beforeDate',
                    msg: $t('verify_cannot_exceed_the_trial_period_end_date')
                  }
                ])
              )
            "
                              :label="$t('label_The_date_of_entry_to_the_company') + '*'"
                              v-model="stafflist.entry_datetime"></mrc_ess_datePicker>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_datePicker :disabled="false"
                              :label="$t('label_The_end_date_of_the_trial_period') + '*'"
                              :errMsg="
              $errors(
                'stafflist',
                'probation_end',
                requiredRule.concat([
                  {
                    rule: 'afterDate',
                    msg: $t('verify_no_later_than_the_date_of_entry_into_the_company')
                  }
                ])
              )
            "
                              v-model="stafflist.probation_end"></mrc_ess_datePicker>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <!-- :errMsg="$errors('stafflist','cost_center_uuid',requiredRule)" -->
          <mrc_ess_prompt :label="$t('label_addStaff_m_costCenter')"
                          :rules="false"
                          :disabled="disabled"
                          v-model="stafflist.cost_center_uuid"
                          :obj="{
              org_level_uuid: $store.state.currentCompany,
              prompt_name: 'cost_center'
            }">
          </mrc_ess_prompt>
        </v-col>
        <v-col cols="12">
          <mrc_ess_prompt :label="$t('label_commonHoliday')"
                          :rules="false"
                          :disabled="disabled"
                          v-model="stafflist.holiday_group"
                          :obj="{
              prompt_name: 'ess_holiday_group_select'
            }">
          </mrc_ess_prompt>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn @cancel="cancel"
                       @success="success"
                       :successText="$t('label_The_next_step')"></mrc_ess_submitBtn>
  </v-card>
</template>
<style scoped></style>
<script>
import { verificationStaffId } from '@/service/api/staffPropertyGroup.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {},
  data () {
    return {
      branduploadstatus: true,
      items: [],
      disabled: false,
      stafflist: {
        holiday_group: '',
        job_post_uuid: '', //所属岗位
        org_level_uuid: '', //所属公司
        show_name: '', //显示名字
        job_post_grade_uuid: '', //岗位等级
        given_name: '', //名
        child_name: '', //小名
        christian_name: '', //员工洋名
        role_uuids: '', //所属角色
        dept_uuid: '', //所属部门
        family_name: '', //员工姓
        staff_email: '', //邮箱
        is_dept_manage: 0, //	是否部门负责人 1是 0否
        is_org_manager: 0, //	是否单位负责人 1是 0否
        direct_leader_code: '', //	直属领导
        staff_image: '', //头像
        staff_status: 1,
      },
      file: '', //上传的图片
    }
  },
  validations: {
    stafflist: {
      given_name: {
        required,
        //  maximumLength: maximumLength(10)
      },
      family_name: {
        required,
      },
      child_name: {},
      show_name: {
        required,
      },
      gender: {
        required,
      },
      staff_email: {
        // required,
        email,
      },
      staff_type: {
        required,
      },
      staff_code: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      dept_uuid: {
        required,
      },
      job_post_uuid: {
        required,
      },
      staff_grade: {
        required,
      },
      // job_post_grade_uuid: {
      //   required,
      // },
      is_org_manager: {},
      is_dept_manage: {},
      direct_leader_code: {},
      role_uuids: {
        required,
      },
      entry_datetime: {
        required,
        beforeDate (value) {
          if (!this.stafflist.probation_end) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.stafflist.probation_end).valueOf()
          return prevData <= nextData
        },
      },
      probation_end: {
        required,
        afterDate (value) {
          if (!this.stafflist.entry_datetime) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.stafflist.entry_datetime).valueOf()
          return prevData <= nextData
        },
      },
      // cost_center_uuid: {
      //   required
      // }
    },
  },
  created () { },
  async mounted () {
    await this.national('mrbase_sys_staffs')
  },
  methods: {
    blur () {
      if (!this.stafflist.staff_code) return
      verificationStaffId({ staff_code: this.stafflist.staff_code }).then(
        (res) => {
          if (res.code == 200) {
            if (res.status == 200) {
            }
            else { //4.23改  杨东
              this.stafflist.staff_code = ""
              this.$myConfirm({
                content: this.INT(res.data),
                cancelShow: false,
              })
                .then(() => { })
                .catch(() => { })
            }
            // if (res.status == 201) {
            //   this.$myConfirm({
            //     content: this.INT(res.data),
            //     cancelShow: false,
            //   })
            //     .then(() => { })
            //     .catch(() => { })
            // }
          }
        }
      )
    },
    reset () {
      this.$v.stafflist.$reset()
      this.stafflist = {}
      this.file = ''
      this.branduploadstatus = false
      this.$nextTick(() => {
        this.branduploadstatus = true
      })
    },
    changeimgSrc (v) {
      this.file = v
    },
    cancel () { },
    success () {
      this.$v.stafflist.$touch()
      if (this.$v.stafflist.$error) return
      this.stafflist.org_level_uuid = this.company_uuid
      this.$emit('changee1', 2, this.stafflist, this.file)
      // verificationStaffId({ staff_code: this.stafflist.staff_code }).then(res => {
      //   if (res.code == 200) {
      //     if (res.status == 200) {
      //       this.$emit('changee1', 2, this.stafflist, this.file)
      //     }
      //     if (res.status == 201) {
      //       this.$myConfirm({ content: this.INT(res.data), cancelShow: false })
      //         .then(() => {
      //           this.$emit('changee1', 2, this.stafflist, this.file)
      //         }).catch(() => {
      //           this.$emit('changee1', 2, this.stafflist, this.file)
      //         })
      //     }
      //   }
      // })
      // return
      // this.stafflist.org_level_uuid = this.company_uuid
    },
  },
  computed: {
    company_uuid () {
      //当前选中公司
      return this.$store.state.currentCompany
    },
    staffTypePro () { //员工类型参照
      return {
        prompt_name: 'staff_type',
        org_level_uuid: this.company_uuid,
      }
    },
    staffGrade () { //员工等级参照
      return {
        prompt_name: 'staff_grade',
        org_level_uuid: this.company_uuid,
      }
    },
    companyName () {
      //部门参照查询字段
      return {
        prompt_name: 'levelUuid_deptUuid',
        org_level_uuid: this.company_uuid,
      }
    },
    job_post_uuid () {
      //岗位查询
      return {
        prompt_name: 'level-dept-post',
        dept_uuid: this.stafflist.dept_uuid,
      }
    },
    superior () {
      //上司高级参照
      // return { prompt_name: 'new_boss', org_level_uuid: this.company_uuid }
      return { prompt_name: 'superior', org_level_uuid: this.company_uuid }
    },
    spica () {
      //角色高级参照
      return { prompt_name: 'level-role', org_level_uuid: this.company_uuid }
    },
    mrbase_sys_job_post_grades () {
      return {
        prompt_name: 'mrbase_sys_job_post_grades',
        job_post_uuid: this.stafflist.job_post_uuid,
      }
    },
  },
  watch: {},
}
</script>

<style scoped></style>
